export const fullScreenButtonStyle = {
    py: 1.5,
    fontSize: '1.1rem',
    fontFamily: '"Playfair Display", serif',
    background: 'linear-gradient(135deg, #2B2E4A 0%, #3D4066 100%)',
    '&:hover': {
        background: 'linear-gradient(135deg, #3D4066 0%, #2B2E4A 100%)',
    }
} as const; 